import { object, string, number } from "yup";

export const respiratoryRateSchema = object({
    breathPerMin: number()
        .typeError("Breath must be a number")
        
        .min(2, "Breath must be greater than or equal to 2")
        .max(60, "Breath must be less than or equal to 60")
});